import { LoginLayout } from "@app/components";
import React from "react";

export default function SignUp() {
  return (
    <>
      <LoginLayout path="/sign-up" label="Sign Up"></LoginLayout>
    </>
  );
}
